import React from 'react';
import { Provider } from 'react-redux';
import { store } from './store/getstore';
import { Platform } from 'react-native';
import AppRoutes from './routes';
import Navigation from './Navigation';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Toast from 'react-native-toast-message';
import { installAuthInterceptors } from './apiCalls/authInterceptor';

// Attach the bearer token to every API request (axios + fetch) app-wide.
installAuthInterceptors();

export default function App() {
  return (
    <>
      <Provider store={store}>
        {/* Navigation renders its own NavigationContainer */}
        {Platform.OS === 'web' ? <AppRoutes /> : <Navigation />}
      </Provider>
      {Platform.OS === 'web' ? (
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 999999 }}
        />
      ) : (
        <Toast />
      )}
    </>
  );
}
